var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser)?_c('div',{class:{'document-page':true, mobile: _vm.$api.isMobile(), desktop: !_vm.$api.isMobile()}},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }